// extracted by mini-css-extract-plugin
module.exports = {"img":"styles-module--img--2wbj7","list":"styles-module--list--2bD-A"};